import React from "react";
import "./RolesResponsibilities.css";

const RolesResponsibilities = () => {
  return (
    <div className="roles">
      <h3>Key Responsibilities</h3>
      <h4>Project Management</h4>
      <ul>
        <li>
          Communication with Project Manager, Solution Architect &amp; Client
        </li>
        <li>Providing estimates, technical documents</li>
        <li>Defining scopes</li>
        <li>Tracking progress of each task</li>
        <li>Preparing release &amp; sharing with client</li>
      </ul>
      <h4>Technical Responsibilities</h4>
      <ul>
        <li>App build &amp; distribution</li>
        <li>Code review</li>
        <li>Merging, reviewing, resolving code conflicts</li>
        <li>Developing mockups for Apps</li>
        <li>Describing development requirements to developers</li>
        <li>Assigning tasks</li>
        <li>Support on technical challenges</li>
        <li>Research and development</li>
        <li>Scheduling &amp; taking Knowledge sharing sessions</li>
        <li>Writing Unit test cases &amp; UI Test cases</li>
        <li>Application developer level testing</li>
      </ul>
    </div>
  );
};

export default RolesResponsibilities;
